<template>
	<div class="dpIB fWhite">
		<!-- 电站状态 -->
		<div v-if="type == 'plant' && id == 'NORMAL'" :title="$t('word1461', ['通讯正常'])">
			<Icon name="shield-yes" class="fSuccess w2x h2x" />
		</div>
		<div v-else-if="type == 'plant' && id == 'ALL_OFFLINE'" :title="getLanguageStr('word1659', '全部设备离线')">
			<Icon name="offline-all" class="fRed w2x h2x" />
		</div>
		<div v-else-if="type == 'plant' && id == 'PARTIAL_OFFLINE'" :title="getLanguageStr('word1677', '部分设备离线')">
			<Icon name="offline-part" class="fYellow w2x h2x" />
		</div>
		<div v-else-if="type == 'plant' && id == 'NO_DEVICE'" :title="$t('word1269', ['接入中'])">
			<Icon name="time" class="fDanger w2x h2x" />
		</div>
		<!-- 异常电站状态 -->
		<div v-else-if="type == 'abnormalStation' && id === 'ALL'">
			<div class="icoSys dvStatus bgPrimary" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('plant40', ['全部设备离线电站'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
		</div>
		<div v-else-if="type == 'abnormalStation' && id === 'PART'">
			<div class="icoSys dvStatus bgYellow" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('plant41', ['部分设备离线电站'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
		</div>
		<div v-else-if="type == 'abnormalStation' && id === 'ALERT'">
			<div class="icoSys dvStatus bgError" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('plant_alert27', ['有报警'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
		</div>
		<!-- 工单状态  -->
		<div v-else-if="type == 'workOrderState' && id === 'WAIT_PICK'">
			<div class="icoSys dvStatus bgYellow" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket2', ['待接受'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket2", "待接受") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'WAIT_HANDLE'">
			<div class="icoSys dvStatus bgYellow" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket4', ['待处理'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket4", "待处理") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'IN_HANDLE'">
			<div class="icoSys dvStatus bgMain" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('task6', ['执行中'])">
				<Icon v-if="showType == 'ico'" class="fBlue" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("task6", "执行中") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'WAIT_APPROVE'">
			<div class="icoSys dvStatus bgYellow" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket6', ['待验证'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket6", "待验证") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'WAIT_EVALUATE'">
			<div class="icoSys dvStatus bgYellow" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket7', ['待评价'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket7", "待评价") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'FINISH'">
			<div class="icoSys dvStatus bgSuccess" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket8', ['已完成'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket8", "已完成") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'CANCEL'">
			<div class="icoSys dvStatus bgFail" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket9', ['已撤销'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket9", "已撤销") }}</span>
		</div>
		<div v-else-if="type == 'workOrderState' && id === 'REJECT'">
			<div class="icoSys dvStatus bgWarning" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('ticket3', ['拒绝接受'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("ticket3", "拒绝接受") }}</span>
		</div>
		<!-- 设备状态 0：未激活 1：在线 2：报警 3：离线  -->
		<div v-else-if="type == 'device' && id === 0">
			<div class="icoSys dvStatus bgNeutral" :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('word94', ['未激活'])">
				<Icon v-if="showType == 'ico'" name="unon" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("word94", "未激活") }}</span>
		</div>
		<div v-else-if="type == 'device' && (id === 'ONLINE' || id === 1)">
			<div :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('word1588', ['在线'])">
				<Icon v-if="showType == 'ico'" name="shield-yes" class="fSuccess w2x h2x" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("word1588", "在线") }}</span>
		</div>
		<div v-else-if="type == 'device' && (id === 'ALERT' || id === 2)">
			<div :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('plant_alert59', ['报警'])">
				<Icon v-if="showType == 'ico'" name="status-alarm" class="fDanger w2x h2x" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("plant_alert59", "报警") }}</span>
		</div>
		<div v-else-if="type == 'device' && (id === 'OFFLINE' || id === 3)">
			<div :class="{ 'icoSys-mini': showType == 'mini' }" :title="$t('word64', ['离线'])">
				<Icon v-if="showType == 'ico'" name="offline-all" class="fWarning w2x h2x" />
			</div>
			<span v-if="showType == 'mini'">{{ getLanguageStr("word64", "离线") }}</span>
		</div>
		<!-- 父设备状态  1：在线 2：报警 3：离线  -->
		<div v-else-if="type == 'parDevice' && (id === 'ONLINE' || id === 1)" :title="$t('word1588', ['在线'])">
			<Icon name="shield-yes" class="fSuccess w2x h2x" />
		</div>
		<div v-else-if="type == 'parDevice' && (id === 'ALERT' || id === 2)" :title="$t('plant_alert59', ['报警'])">
			<Icon name="status-alarm" class="fDanger w2x h2x" />
		</div>
		<div v-else-if="type == 'parDevice' && (id === 'OFFLINE' || id === 3)" :title="$t('word64', ['离线'])">
			<Icon name="offline-all" class="fWarning w2x h2x" />
		</div>
		<!-- 激活状态 -->
		<div v-else-if="type == 'activedState' && id == 1" :title="$t('word93', ['已激活'])">
			<Icon name="on" class="fSuccess w2x h2x" />
		</div>
		<div v-else-if="type == 'activedState' && id == 0" :title="$t('word94', ['未激活'])">
			<Icon name="unon" class="fLight w2x h2x" />
		</div>
		<!-- 	<div v-if="type=='device'&&id=='ALERT'" class="icoSys dvStatus bgWarning" :title="$t('plant_alert59',['报警'])">
		<svg><use xlink:href="#ico-dvStatus-warning"></use></svg>
	</div> -->

		<!-- 报警状态 -->
		<div v-else-if="type == 'alarm' && (id === 'ALERTING' || id >= 0)" :title="$t('word1464', ['有报警'])">
			<Icon name="status-alarm" class="w2x h2x fDanger" />
		</div>
		<div v-else-if="type == 'alarm' && (id === 'NORMAL' || id < 0)" :title="$t('word1465', ['无报警'])">
			<Icon name="shield-yes" class="w2x h2x fSuccess" />
		</div>

		<!-- 设备报警状态 -1 无报警 其他：有报警 -->
		<div v-else-if="type == 'deviceAlarm' && (id === 'ALERTING' || id >= 0)" :title="$t('word1464', ['有报警'])">
			<Icon name="status-alarm" class="w2x h2x fDanger" />
		</div>
		<div v-else-if="type == 'deviceAlarm' && (id === 'NORMAL' || id < 0)" :title="$t('word1465', ['无报警'])">
			<Icon name="shield-yes" class="w2x h2x fSuccess" />
		</div>

		<!-- 成员状态 -->
		<div v-else-if="type == 'statusUser' && id === 1" class="icoSys dvStatus bgError" :title="$t('word94', ['未激活'])">
			<Icon name="no" />
		</div>
		<div v-else-if="type == 'statusUser' && id === 2" class="icoSys dvStatus bgSuccess" :title="$t('word93', ['已激活'])">
			<Icon name="yes" />
		</div>
		<!-- $t('word167',['建设中'])
	<div v-if="type=='plant'&&id==5" class="icoSys dvStatus bgGreen" language-title="word219,入库未激活" ico="5">
		<svg><use xlink:href="#ico-dvStatus-storage"></use></svg>
	</div>
	<div v-if="type=='plant'&&id==6" class="icoSys dvStatus bgBlueLight" language-title="word220,激活未注册" ico="6">
		<svg><use xlink:href="#ico-dvStatus-activation"></use></svg>
	</div>
	 --></div>
</template>
<script>
import { getLanguageStr } from "@/util/language.js";
export default {
	name: "StatusIco",
	components: {},
	props: {
		id: {
			type: [String, Number],
			default: "",
		},
		type: {
			// 指定适配的类型
			type: String,
			default: "",
		},
		showType: {
			// 激活的索引项
			type: String,
			default: "ico", //ico,mini
		},
	},
	data() {
		return {};
	},
	methods: {
		getLanguageStr,
	},
	created() {},
	mounted() {},
};
</script>
<style lang="scss" scoped>
.icoSys-mini {
	display: inline-block;
	width: 0.5em;
	height: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/StatusIco.vue